"use client";

import Image from "next/image";
import { useState, useEffect } from "react";
import BackToTop from "@/assets/icon/back-to-top.svg?url";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeoutId;
    const handlePageScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsVisible(window.scrollY > 150);
      }, 100); // adjust delay as needed
    };

    window.addEventListener("scroll", handlePageScroll, { passive: true });
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("scroll", handlePageScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to Top"
      className={`iconOnly back-to-top ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <span>
        <Image
          width={64}
          height={64}
          unoptimized
          src={BackToTop}
          alt="back-to-top"
        />
      </span>
      <span></span>
    </button>
  );
};

export default BackToTopButton;
